import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useAuth } from '../contexts/AuthContext'
import PreviewWall from './PreviewWall'
import '../styles/app.css'
import '../styles/app-mobile.css'

const bookmakerData = [
  { id: 1, name: "123Bet", link: "https://www.123bet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/123bet.png", oddsFeed: "ApolloTech", company: "Winners Bookmaking", depositBonus: "200/50", supported: "Yes", notes: "" },
  { id: 2, name: "AllBets", link: "https://allbets.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/allbetsnew.jpg", oddsFeed: "AllBets", company: "Allbets.com.au", depositBonus: "", supported: "Yes", notes: "" },
  { id: 3, name: "Baggybet", link: "https://www.baggybet.com/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BaggyBet.jpg", oddsFeed: "BetMakers", company: "Mailbag Wagering", depositBonus: "150/75", supported: "Yes", notes: "" },
  { id: 4, name: "Bearbet", link: "https://www.bearbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BearBet.png", oddsFeed: "ApolloTech", company: "Bet Holdings", depositBonus: "500/150", supported: "Yes", notes: "" },
  { id: 5, name: "Bet365", link: "https://www.bet365.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BET365.png", oddsFeed: "Bet365", company: "Hillside (Australia New Media)", depositBonus: "100/100", supported: "Yes", notes: "Important bookmaker: mug properly" },
  { id: 6, name: "bet575", link: "https://bet575.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Bet575.jpg", oddsFeed: "BetCloud", company: "Beasley, Simon", depositBonus: "", supported: "Yes", notes: "" },
  { id: 7, name: "Bet66", link: "https://www.bet66.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/bet66.png", oddsFeed: "BetMakers", company: "Dow, Anthony", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 8, name: "Bet777", link: "https://bet777.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Bet777.webp", oddsFeed: "BetCloud", company: "Fitzpatrick, Gary Michael", depositBonus: "", supported: "Yes", notes: "" },
  { id: 9, name: "BetAlpha", link: "https://www.betalpha.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetAlpha.webp", oddsFeed: "PuntersTech", company: "Mintsports", depositBonus: "", supported: "Yes", notes: "" },
  { id: 10, name: "BetAus", link: "https://betaus.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetAus.jpg", oddsFeed: "BetMakers", company: "BetAus", depositBonus: "", supported: "Yes", notes: "" },
  { id: 11, name: "BetBetBet", link: "https://www.betbetbet.net.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BETBETBET.png", oddsFeed: "Generation Web", company: "Betbetbet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 12, name: "BetBlitz", link: "https://www.betblitz.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetBlitz.png", oddsFeed: "PuntersTech", company: "Hudson, Frank", depositBonus: "", supported: "Yes", notes: "" },
  { id: 13, name: "BetBuzz", link: "https://www.betbuzz.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetBuzz.webp", oddsFeed: "PuntersTech", company: "Mintsports", depositBonus: "", supported: "Yes", notes: "" },
  { id: 14, name: "BetChamps", link: "https://www.betchamps.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/betchamps.png", oddsFeed: "PuntersTech", company: "Millett, Carl", depositBonus: "", supported: "Yes", notes: "" },
  { id: 15, name: "BetDeluxe", link: "https://www.betdeluxe.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetDeluxe.jpg", oddsFeed: "BlackStream", company: "Amused Australia", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 16, name: "BetDragon", link: "https://www.betdragon.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/BETDRAGON.png", oddsFeed: "PuntersTech", company: "Mintsports", depositBonus: "", supported: "Yes", notes: "" },
  { id: 17, name: "BetEstate", link: "https://betestate.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/betestate.png", oddsFeed: "BetMakers", company: "Betestate", depositBonus: "50/50", supported: "Yes", notes: "" },
  { id: 18, name: "BetExpress", link: "https://www.betexpress.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/betexpress.jpeg", oddsFeed: "BlackStream", company: "Amused Australia", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 19, name: "BetFocus", link: "https://www.betfocus.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/betfocus.png", oddsFeed: "PuntersTech", company: "Betfocus", depositBonus: "", supported: "Yes", notes: "" },
  { id: 20, name: "BetGalaxy", link: "https://betgalaxy.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetGalaxy.jpg", oddsFeed: "BetCloud", company: "Track Pursuits", depositBonus: "", supported: "Yes", notes: "" },
  { id: 21, name: "BetGold", link: "https://betgold.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BETGOLD.jpg", oddsFeed: "AllBets", company: "Goldbet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 22, name: "BetJet", link: "https://betjet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetJet.jpeg", oddsFeed: "BlackStream", company: "Amused Australia", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 23, name: "BetKings", link: "https://www.betkings.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetKings.png", oddsFeed: "ApolloTech", company: "Betmax", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 24, name: "BetLocal", link: "https://betlocal.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BETLOCAL.jpg", oddsFeed: "BetMakers", company: "Betlocal", depositBonus: "200/100", supported: "Yes", notes: "" },
  { id: 25, name: "BetM", link: "https://betm.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetM.jpeg", oddsFeed: "BetMakers", company: "MGB Australia", depositBonus: "100/100", supported: "Yes", notes: "", ceased: true },
  { id: 26, name: "BetMax", link: "https://www.betmax.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetMax.jpg", oddsFeed: "ApolloTech", company: "Betmax", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 27, name: "BetNation", link: "https://betnation.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetNation.png", oddsFeed: "BlackStream", company: "Amused Australia", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 28, name: "BetPlay", link: "https://www.betplay.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetPlay.jpeg", oddsFeed: "ApolloTech", company: "Winners Bookmaking", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 29, name: "BetProfessor", link: "https://betprofessor.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BETPROFESSOR.png", oddsFeed: "BetCloud", company: "Giant Bet", depositBonus: "250/50", supported: "Yes", notes: "" },
  { id: 30, name: "BetR", link: "https://betr.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BETR.jpg", oddsFeed: "BetR", company: "Bluebet", depositBonus: "100/100", supported: "Yes", notes: "Important bookmaker: mug properly" },
  { id: 31, name: "BetReal", link: "https://www.betreal.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetReal.png", oddsFeed: "PuntersTech", company: "Crownsport Australia", depositBonus: "", supported: "Yes", notes: "" },
  { id: 32, name: "BetRight", link: "https://www.betright.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BETRIGHT.jpg", oddsFeed: "BetRight", company: "IRPSX", depositBonus: "100/100", supported: "Yes", notes: "Important bookmaker: mug properly" },
  { id: 33, name: "BetRoyale", link: "https://betroyale.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BetRoyal.jpeg", oddsFeed: "BetCloud", company: "Betroyale", depositBonus: "300/120", supported: "Yes", notes: "", ceased: true },
  { id: 34, name: "Betyoucan", link: "https://betyoucan.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Betyoucan.png", oddsFeed: "BetMakers", company: "Bet You Can", depositBonus: "", supported: "Yes", notes: "" },
  { id: 35, name: "BetSupreme", link: "https://betsupreme.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/BETSUPRMEME.png", oddsFeed: "BetMakers", company: "Bet Supreme", depositBonus: "", supported: "Yes", notes: "" },
  { id: 36, name: "Betzooka", link: "https://www.betzooka.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Betzooka.png", oddsFeed: "BetMakers", company: "Bossbet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 37, name: "BigBet", link: "https://www.bigbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BigBet.png", oddsFeed: "BlackStream", company: "Amused Australia", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 38, name: "BlondeBet", link: "https://www.blondebet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BlondeBet.png", oddsFeed: "PuntersTech", company: "Pendlebury Bookmaking", depositBonus: "", supported: "Yes", notes: "" },
  { id: 39, name: "BoomBet", link: "https://boombet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BoomBet.jpeg", oddsFeed: "Generation Web", company: "Boombet", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 40, name: "BoostBet", link: "https://boostbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BoostBet.png", oddsFeed: "AllBets", company: "Boostbet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 41, name: "BossBet", link: "https://bossbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BossBet.jpeg", oddsFeed: "BetMakers", company: "Bossbet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 42, name: "BuffaloBet", link: "https://buffalobet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/BuffaloBet.webp", oddsFeed: "BetCloud", company: "McGrath, Damien", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 43, name: "CashCage", link: "https://www.cashcage.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/CashCage.png", oddsFeed: "PuntersTech", company: "Razoo Entertainment", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 44, name: "ChaseBet", link: "https://www.chasebet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/CHASEBET.png", oddsFeed: "PuntersTech", company: "Harris Bookmaking", depositBonus: "", supported: "Yes", notes: "" },
  { id: 45, name: "Chromabet", link: "https://www.chromabet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/chromabet.jpg", oddsFeed: "BetCloud", company: "Mansour, G & T", depositBonus: "", supported: "Yes", notes: "" },
  { id: 46, name: "ColossalBet", link: "https://www.colossalbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/ColossalBet.jpeg", oddsFeed: "Generation Web", company: "Ryman, Mark", depositBonus: "200/100", supported: "Yes", notes: "" },
  { id: 47, name: "CrossBet", link: "https://crossbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/CrossBet.png", oddsFeed: "BetMakers", company: "Cross Bet", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 48, name: "Dabble", link: "https://www.dabble.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/DABBLE.png", oddsFeed: "Dabble", company: "Dabble Sports", depositBonus: "Random", supported: "Yes", notes: "Important bookmaker: mug properly" },
  { id: 49, name: "DashBet", link: "https://www.dashbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/DashBet.jpeg", oddsFeed: "Generation Web", company: "Betting Services Australia", depositBonus: "", supported: "Yes", notes: "" },
  { id: 50, name: "DiamondBet", link: "https://diamondbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/DiamondBet.jpg", oddsFeed: "BetMakers", company: "DiamondBet", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 51, name: "DowBet", link: "https://dowbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/DowBet.webp", oddsFeed: "BetMakers", company: "Dowbet", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 52, name: "Elitebet", link: "https://www.elitebet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Elitebet.png", oddsFeed: "Generation Web", company: "Paolini, Daniel", depositBonus: "", supported: "Yes", notes: "" },
  { id: 53, name: "FavBet", link: "https://favbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/FavBet.webp", oddsFeed: "ApolloTech", company: "Winners Bookmaking", depositBonus: "200/50", supported: "Yes", notes: "", ceased: true },
  { id: 54, name: "FiestaBet", link: "https://fiestabet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/FIESTABET.png", oddsFeed: "BetCloud", company: "McLauchlin, David", depositBonus: "300/150", supported: "Yes", notes: "" },
  { id: 55, name: "GigaBet", link: "https://www.gigabet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/GigaBet.png", oddsFeed: "BetCloud", company: "Viking Gaming", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 56, name: "GoldBet", link: "https://www.goldbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/GOLDBET.png", oddsFeed: "AllBets", company: "Goldbet", depositBonus: "200/200", supported: "Yes", notes: "" },
  { id: 57, name: "GoldenBet888", link: "https://goldenbet888.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/GOLDENBET888.png", oddsFeed: "BetCloud", company: "Fortunas Felicitas", depositBonus: "", supported: "Yes", notes: "" },
  { id: 58, name: "GoldenRush", link: "https://goldenrush.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/GOLDENRUSH.png", oddsFeed: "BetCloud", company: "McGrath & McGrath", depositBonus: "250/50", supported: "Yes", notes: "", ceased: true },
  { id: 59, name: "GRSBet", link: "https://www.grsbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/GRSBET.png", oddsFeed: "GRSBet", company: "Crispe, Stephen", depositBonus: "", supported: "", notes: "" },
  { id: 60, name: "HavaBet", link: "https://havabet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/HavaBet.png", oddsFeed: "Generation Web", company: "Havabet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 61, name: "HotBet", link: "https://www.hotbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/HotBet.jpeg", oddsFeed: "Generation Web", company: "Deguara Cross Bookmaking", depositBonus: "", supported: "Yes", notes: "" },
  { id: 62, name: "JimmyBet", link: "https://www.jimmybet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/JimmyBet.png", oddsFeed: "Generation Web", company: "Jimmybet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 63, name: "JuicyBet", link: "https://juicybet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/JUICYBET.png", oddsFeed: "BetCloud", company: "Juicybet", depositBonus: "200/40", supported: "Yes", notes: "" },
  { id: 64, name: "Junglebet", link: "https://www.junglebet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/JUNGLEBET.png", oddsFeed: "BetCloud", company: "Jungle Strategic", depositBonus: "100/50", supported: "Yes", notes: "" },
  { id: 65, name: "JustBet", link: "https://www.justbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/JustBet.png", oddsFeed: "Generation Web", company: "Justbet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 66, name: "Ladbrokes", link: "https://www.ladbrokes.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/LADBROKES.png", oddsFeed: "Entain", company: "Entain Group", depositBonus: "250/250", supported: "Yes", notes: "Important bookmaker: mug properly" },
  { id: 67, name: "LetsBet", link: "https://letsbet.net.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/LetsBet.webp", oddsFeed: "Generation Web", company: "Let's Bet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 68, name: "LightningBet", link: "https://www.lightningbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/LightningBet.png", oddsFeed: "PuntersTech", company: "Lynch, Grant", depositBonus: "", supported: "Yes", notes: "" },
  { id: 69, name: "MarantelliBet", link: "https://www.marantellibet.com/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/MarantelliBet.jpg", oddsFeed: "BetMakers", company: "MarantelliBet", depositBonus: "100/50", supported: "Yes", notes: "" },
  { id: 70, name: "MidasBet", link: "https://www.midasbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/MidasBet.png", oddsFeed: "Generation Web", company: "Betting Services Australia", depositBonus: "250/125", supported: "Yes", notes: "" },
  { id: 71, name: "MightyBet", link: "https://www.mightybet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/MightyBet.png", oddsFeed: "BlackStream", company: "Amused Australia", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 72, name: "MillennialBet", link: "https://www.millennialbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/MILLENIALBET.png", oddsFeed: "PuntersTech", company: "Pendlebury Bookmaking", depositBonus: "", supported: "Yes", notes: "" },
  { id: 73, name: "MintBet", link: "https://www.mintbet.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/MintBet.png", oddsFeed: "PuntersTech", company: "Mintsports", depositBonus: "75/75", supported: "Yes", notes: "" },
  { id: 74, name: "MyBet", link: "https://www.mybet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/MyBet.jpeg", oddsFeed: "Generation Web", company: "Mybet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 75, name: "Neds", link: "https://www.neds.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Neds.jpg", oddsFeed: "Entain", company: "Entain Group", depositBonus: "150/150", supported: "Yes", notes: "Important bookmaker: mug properly" },
  { id: 76, name: "NinjaBet", link: "https://www.ninjabet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/NINJABET.png", oddsFeed: "Generation Web", company: "Betting Services Australia", depositBonus: "", supported: "Yes", notes: "" },
  { id: 77, name: "Next2go", link: "https://next2go.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Next2go.jpeg", oddsFeed: "BetMakers", company: "Zinger Bookmaking", depositBonus: "", supported: "Yes", notes: "" },
  { id: 78, name: "Noisy", link: "https://www.noisy.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Noisy.png", oddsFeed: "BlackStream", company: "Amused Australia", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 79, name: "OkeBet", link: "https://okebet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/OKEBET.png", oddsFeed: "BetMakers", company: "Oke Bet", depositBonus: "150/75", supported: "Yes", notes: "" },
  { id: 80, name: "OldGill", link: "https://oldgill.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/OLDGILL.png", oddsFeed: "BetCloud", company: "Engellener, Gregory John", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 81, name: "Palmerbet", link: "https://www.palmerbet.com/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PALMERBET.jpg", oddsFeed: "PalmerBet", company: "Palmer Bookmaking", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 82, name: "PandaBet", link: "https://www.pandabet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PandaBet.webp", oddsFeed: "Generation Web", company: "Betting Services Australia", depositBonus: "", supported: "Yes", notes: "" },
  { id: 83, name: "PickleBet", link: "https://picklebet.com/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PickleBet.jpeg", oddsFeed: "PickleBet", company: "Puntaa", depositBonus: "50/50", supported: "Yes", notes: "" },
  { id: 84, name: "PicnicBet", link: "https://picnicbet.com/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PicnicBet.jpg", oddsFeed: "BetMakers", company: "Boncorp Holdings", depositBonus: "", supported: "Yes", notes: "" },
  { id: 85, name: "NextBet", link: "https://www.nextbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/NextBetLogo.png", oddsFeed: "NextBet", company: "NextBet Pty Ltd", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 86, name: "Playwest", link: "https://playwestbet.com/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/PLAYWEST.jpeg", oddsFeed: "BetMakers", company: "PlayWest", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 87, name: "PointsBet", link: "https://pointsbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/POINTSBETWEBSITE.png", oddsFeed: "Pointsbet", company: "Pointsbet Australia", depositBonus: "100/100", supported: "Yes", notes: "Important bookmaker: mug properly" },
  { id: 88, name: "PonyBet", link: "https://www.ponybet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PonyBet.png", oddsFeed: "BetMakers", company: "Booki.com.au", depositBonus: "50/50", supported: "Yes", notes: "" },
  { id: 89, name: "PremiumBet", link: "https://premiumbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PremiumBet.png", oddsFeed: "BetMakers", company: "Hudson, Frank", depositBonus: "200/50", supported: "Yes", notes: "" },
  { id: 90, name: "PulseBet", link: "https://www.pulsebet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Pulsebet.png", oddsFeed: "BlackStream", company: "Amused Australia", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 91, name: "Punt123", link: "https://www.punt123.bet/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Punt123.jpg", oddsFeed: "BetMakers", company: "Harrak, Michael", depositBonus: "150/75", supported: "Yes", notes: "" },
  { id: 92, name: "PuntCity", link: "https://www.puntcity.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PUNTCITY.png", oddsFeed: "BetCloud", company: "Pcity", depositBonus: "100/50", supported: "Yes", notes: "", ceased: true },
  { id: 93, name: "PuntGenie", link: "https://puntgenie.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PUNTGENIE.png", oddsFeed: "BetCloud", company: "Sylvester, Jason", depositBonus: "200/100", supported: "Yes", notes: "", ceased: true },
  { id: 94, name: "PuntNOW", link: "https://www.puntnow.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PUNTNOW.png", oddsFeed: "Generation Web", company: "Puntnow", depositBonus: "", supported: "Yes", notes: "" },
  { id: 95, name: "PuntOnDogs", link: "https://www.puntondogs.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PuntOnDogs.png", oddsFeed: "BetMakers", company: "Dogbet", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 96, name: "PuntZone", link: "https://www.puntzone.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/PuntZone.jpg", oddsFeed: "Generation Web", company: "Betting Services Australia", depositBonus: "", supported: "Yes", notes: "" },
  { id: 97, name: "QuestBet", link: "https://www.questbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/QUESTBET.png", oddsFeed: "BetCloud", company: "Questbet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 98, name: "ReadyBet", link: "https://www.readybet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/ReadyBet.jpeg", oddsFeed: "BetMakers", company: "Readybet", depositBonus: "200/100", supported: "Yes", notes: "" },
  { id: 99, name: "RealBookie", link: "https://www.realbookie.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/RealBookie.jpeg", oddsFeed: "BetMakers", company: "Realbookie.com.au", depositBonus: "200/200", supported: "Yes", notes: "" },
  { id: 100, name: "Ripperbet", link: "https://www.ripperbet.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Ripperbet.png", oddsFeed: "PuntersTech", company: "Mintsports", depositBonus: "100/50", supported: "Yes", notes: "" },
  { id: 101, name: "RobWaterhouse", link: "https://www.robwaterhouse.com/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/ROBWATERHOUSE.jpg", oddsFeed: "BetMakers", company: "Waterhouse, Robert", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 102, name: "SlamBet", link: "https://www.slambet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/SlamBet.jpeg", oddsFeed: "BetCloud", company: "Viking Gaming", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 103, name: "SportsChamps", link: "https://www.sportschamps.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/SportsChamps.png", oddsFeed: "SportsChamps", company: "Eskander, Alan", depositBonus: "", supported: "No", notes: "", ceased: true },
  { id: 104, name: "SportsBet", link: "https://www.sportsbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/SPORTSBET.png", oddsFeed: "SportsBet", company: "Sportsbet", depositBonus: "100/100 Seasonal", supported: "Yes", notes: "Important bookmaker: mug properly" },
  { id: 105, name: "StarSports", link: "https://www.starsports.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/StarSports.jpg", oddsFeed: "PuntersTech", company: "Star Sports Australia", depositBonus: "", supported: "Yes", notes: "" },
  { id: 106, name: "SterlingParker", link: "https://www.sterlingparker.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/STERLINGPARKER.png", oddsFeed: "BetCloud", company: "Engellener, G & N", depositBonus: "", supported: "Yes", notes: "" },
  { id: 107, name: "SugarCastle", link: "https://sugarcastle.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/SUGARCASTLE.png", oddsFeed: "BetCloud", company: "Hsu, Lincoln", depositBonus: "", supported: "Yes", notes: "" },
  { id: 108, name: "Surge", link: "https://www.surge.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Surge.webp", oddsFeed: "BlackStream", company: "Amused Australia", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 109, name: "SwiftBet", link: "https://swiftbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/SwiftBet.jpg", oddsFeed: "BetMakers", company: "Swift Bet", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 110, name: "TAB", link: "https://www.tab.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/TAB.jpg", oddsFeed: "TAB", company: "TAB Limited", depositBonus: "100/100", supported: "Yes", notes: "Important bookmaker: mug properly" },
  { id: 111, name: "TabTouch", link: "https://www.tabtouch.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/TabTouch.png", oddsFeed: "Kambi", company: "Racing and Wagering Western Australia", depositBonus: "100/100", supported: "Yes", notes: "Important bookmaker: mug properly" },
  { id: 112, name: "TeamBet", link: "https://www.teambet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/TEAMBET.png", oddsFeed: "PuntersTech", company: "Bonus Kingdom", depositBonus: "", supported: "Yes", notes: "" },
  { id: 113, name: "TempleBet", link: "https://templebet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/TempleBet.jpeg", oddsFeed: "BetCloud", company: "McLauchlan, David", depositBonus: "", supported: "Yes", notes: "" },
  { id: 114, name: "Terrybet", link: "https://www.terrybet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/Terrybet.png", oddsFeed: "BetMakers", company: "Coelli, Terrence", depositBonus: "", supported: "Yes", notes: "" },
  { id: 115, name: "TitanBet", link: "https://www.titanbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/TitanBet.jpg", oddsFeed: "BetCloud", company: "TitanBet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 116, name: "TopBet", link: "https://www.topbet.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/TopBet.png", oddsFeed: "PuntersTech", company: "Betsmarter Group", depositBonus: "500/150", supported: "Yes", notes: "" },
  { id: 117, name: "TradieBet", link: "https://www.tradie.bet/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/TRADIEBET.jpg", oddsFeed: "PuntersTech", company: "Bonus Kingdom", depositBonus: "100/50", supported: "Yes", notes: "" },
  { id: 118, name: "TrueBet", link: "https://www.truebet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/TrueBet.png", oddsFeed: "PuntersTech", company: "Truebet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 119, name: "UltraBet", link: "https://www.ultrabet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/UltraBet.jpeg", oddsFeed: "AllBets", company: "UltraBet", depositBonus: "200/200", supported: "Yes", notes: "" },
  { id: 120, name: "UniBet", link: "https://www.unibet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos/UNIBET.png", oddsFeed: "Kambi", company: "Betchoice Corporation", depositBonus: "50/50", supported: "Yes", notes: "" },
  { id: 121, name: "Upcoz", link: "https://upcoz.com/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/Upcoz.webp", oddsFeed: "BetMakers", company: "UPCOZ", depositBonus: "150/150", supported: "Yes", notes: "" },
  { id: 122, name: "VicBet", link: "https://www.vicbet.com/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/VicBet.jpg", oddsFeed: "Generation Web", company: "Vicbet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 123, name: "VikingBet", link: "https://www.vikingbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/VikingBet.jpg", oddsFeed: "BetCloud", company: "Viking Gaming", depositBonus: "300/120", supported: "Yes", notes: "", ceased: true },
  { id: 124, name: "VinBet", link: "https://www.vinbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/VinBet.png", oddsFeed: "PuntersTech", company: "Vinbet", depositBonus: "", supported: "Yes", notes: "", ceased: true },
  { id: 125, name: "VolcanoBet", link: "https://volcanobet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/VOLCANOBET.jpg", oddsFeed: "BetCloud", company: "Volcano (Aust)", depositBonus: "400/100", supported: "Yes", notes: "", ceased: true },
  { id: 126, name: "WellBet", link: "https://www.wellbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/WELLBET.png", oddsFeed: "BetCloud", company: "Wellbet", depositBonus: "100/100", supported: "Yes", notes: "" },
  { id: 127, name: "WinnersBet", link: "https://www.winnersbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/WinnersBet.jpeg", oddsFeed: "Generation Web", company: "Winnersbet", depositBonus: "75/75", supported: "Yes", notes: "Deposit match [Initital deposit turnover min 1.80 odds (sport) min 1.50 odds (racing) and must turnover twice]" },
  { id: 128, name: "WishBet", link: "https://www.wishbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/WishBet.png", oddsFeed: "BetMakers", company: "Walsh, J.S & Walsh, J.D & O'toole, M.J & Jones, P.W", depositBonus: "500/200", supported: "Yes", notes: "" },
  { id: 129, name: "WizBet", link: "https://www.wizbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/WizBet.png", oddsFeed: "PuntersTech", company: "Wizbet", depositBonus: "", supported: "Yes", notes: "" },
  { id: 130, name: "XBet", link: "https://www.xbet.net.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/XBet.jpg", oddsFeed: "PuntersTech", company: "Millett, Carl", depositBonus: "", supported: "Yes", notes: "" },
  { id: 131, name: "WoodcockRacing", link: "https://woodcockracing.com/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/WoodcockRacing.png", oddsFeed: "MyTrackPrince", company: "Woodcock Racing", depositBonus: "", supported: "", notes: "", ceased: true },
  { id: 132, name: "YesBet", link: "https://www.yesbet.com.au/", logo: "https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/Bookie_Logos2/YesBet.png", oddsFeed: "BlackStream", company: "Amused Australia", depositBonus: "100/100", supported: "Yes", notes: "" }
]

// Closed books (ceased: true) stay in the data above for the record but are
// never shown, counted or offered as a filter option. Use listedBookmakers
// everywhere below, not bookmakerData. To retire a book, add ceased: true.
const listedBookmakers = bookmakerData.filter(b => !b.ceased)


// ——— Inline SVG icons (feather-style, mirror the app's Ionicons) ———
const SearchIcon = ({ size = 16, color = '#64748b' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
)

const XCircleIcon = ({ size = 16, color = '#64748b' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="15" y1="9" x2="9" y2="15"/>
    <line x1="9" y1="9" x2="15" y2="15"/>
  </svg>
)

const LinkIcon = ({ size = 9, color = '#60a5fa' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </svg>
)

const ChevronDownIcon = ({ size = 16, color = '#94a3b8' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
)

const XIcon = ({ size = 22, color = '#94a3b8' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
)

const CheckIcon = ({ size = 18, color = '#60a5fa' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
)

// A select-style filter: a pill that opens a scrollable option list in a modal.
// Mirrors the app's SelectFilter — native <select> option lists can't be styled
// and overflow the screen on long company names.
function SelectFilter({ label, value, options, onChange }) {
  const [open, setOpen] = useState(false)

  // Lock body scroll while the picker is open
  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = prev }
  }, [open])

  const pick = (v) => {
    onChange(v)
    setOpen(false)
  }

  return (
    <>
      <button className="bm-pill" onClick={() => setOpen(true)} style={styles.filterPill}>
        <span style={styles.filterPillText}>{value || label}</span>
        <ChevronDownIcon />
      </button>

      {/* Portal to <body>: the sticky bar's backdrop-filter would otherwise
          trap this fixed overlay inside its own box */}
      {open && createPortal(
        <div className="bm-overlay" style={styles.pickerOverlay} onClick={() => setOpen(false)}>
          <div className="bm-panel" style={styles.pickerPanel} onClick={(e) => e.stopPropagation()}>
            <div style={styles.pickerHeader}>
              <span style={styles.pickerTitle}>{label}</span>
              <button onClick={() => setOpen(false)} style={{ background: 'none', border: 'none', padding: '4px', cursor: 'pointer', display: 'flex' }}>
                <XIcon />
              </button>
            </div>
            <div style={styles.pickerList}>
              {['', ...options].map((item) => {
                const selected = item === value
                return (
                  <button key={item || '__all__'} className="bm-row" onClick={() => pick(item)} style={styles.pickerRow}>
                    <span style={{
                      flex: 1,
                      minWidth: 0,
                      textAlign: 'left',
                      fontSize: '14px',
                      fontWeight: selected ? '600' : '400',
                      color: selected ? '#60a5fa' : '#e2e8f0',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                      {item || `All ${label}`}
                    </span>
                    {selected && <CheckIcon />}
                  </button>
                )
              })}
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  )
}

// Status → accent palette, used for the dot and the chip. Matches the app's statusTheme.
const statusTheme = (status, ceased) => {
  if (ceased) return { dot: '#64748b', chipText: '#94a3b8', label: 'Closed' }
  switch (status) {
    case 'Yes':
      return { dot: '#34d399', chipText: '#6ee7b7', label: 'Supported' }
    case 'No':
      return { dot: '#f87171', chipText: '#fca5a5', label: 'Not supported' }
    default:
      return { dot: '#fbbf24', chipText: '#fbbf24', label: status === 'maintenance' ? 'Maintenance' : status }
  }
}

const styles = {
  container: {
    backgroundColor: '#010714',
    minHeight: '100vh',
    padding: '16px',
    boxSizing: 'border-box'
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    border: '1px solid #1b2538',
    backgroundColor: 'transparent',
    padding: '0 12px'
  },
  searchInput: {
    flex: 1,
    minWidth: 0,
    padding: '11px 8px',
    fontSize: '16px', // 16px+ stops iOS Safari auto-zooming the page on focus
    color: '#f1f5f9',
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none'
  },
  // Pinned under the fixed 53px app header; frosted so cards scroll behind it
  stickyBar: {
    position: 'sticky',
    top: '53px',
    zIndex: 20,
    margin: '-16px -16px 16px',
    padding: '16px 16px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    backgroundColor: 'rgba(1, 7, 20, 0.88)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderBottom: '1px solid #1b2538'
  },
  filterPill: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '4px',
    borderRadius: '8px',
    border: '1px solid #1b2538',
    backgroundColor: 'transparent',
    padding: '12px',
    cursor: 'pointer'
  },
  filterPillText: {
    fontSize: '14px',
    color: '#f1f5f9',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  pickerOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // keep the panel between the fixed 53px header and the ~80px bottom bar
    padding: '69px 16px calc(96px + env(safe-area-inset-bottom, 0px))',
    boxSizing: 'border-box',
    zIndex: 1100
  },
  pickerPanel: {
    width: '100%',
    maxWidth: '420px',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: '12px',
    border: '1px solid #1b2538',
    backgroundColor: '#0a1020'
  },
  pickerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #1b2538',
    padding: '12px 16px',
    flexShrink: 0
  },
  pickerTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#f1f5f9'
  },
  pickerList: {
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch'
  },
  pickerRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    padding: '12px 16px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    boxSizing: 'border-box'
  },
  countRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '4px',
    padding: '0 2px'
  },
  countText: {
    fontSize: '12px',
    color: '#64748b'
  },
  clearBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '600',
    color: '#60a5fa'
  },
  card: {
    background: 'linear-gradient(160deg, #1b2642 0%, #151f36 45%, #121a2e 100%)',
    border: '1px solid #2b3a58',
    borderRadius: '16px',
    padding: '16px',
    cursor: 'pointer',
    overflow: 'hidden',
    boxShadow: '0 4px 14px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(148, 163, 184, 0.07)'
  },
  cardCeased: {
    backgroundColor: '#161b28',
    border: '1px solid #27324a',
    borderRadius: '16px',
    padding: '16px',
    cursor: 'pointer',
    overflow: 'hidden',
    opacity: 0.6
  },
  logoTile: {
    position: 'relative',
    width: '52px',
    height: '52px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    border: '1px solid #1b2538',
    backgroundColor: 'rgba(255,255,255,0.03)',
    flexShrink: 0
  },
  logo: {
    position: 'relative', // paints above the fallback initial
    width: '44px',
    height: '44px',
    borderRadius: '8px',
    objectFit: 'cover'
  },
  logoFallback: {
    position: 'absolute',
    fontSize: '18px',
    fontWeight: '800',
    color: '#475569'
  },
  linkBadge: {
    position: 'absolute',
    bottom: '-4px',
    right: '-4px',
    width: '18px',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    border: '2px solid #1b2538',
    backgroundColor: '#0a1020',
    boxSizing: 'border-box'
  },
  name: {
    fontSize: '17px',
    fontWeight: '700',
    color: '#f8fafc',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  bonusLabel: {
    fontSize: '9px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: '#64748b'
  },
  bonusChip: {
    marginTop: '2px',
    padding: '4px 10px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '700'
  },
  metaPanel: {
    marginTop: '16px',
    display: 'flex',
    gap: '12px',
    borderRadius: '12px',
    border: '1px solid #232e46',
    backgroundColor: '#101828',
    padding: '12px 14px'
  },
  metaLabel: {
    fontSize: '10px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: '#64748b'
  },
  metaValue: {
    marginTop: '2px',
    fontSize: '13px',
    color: '#e2e8f0',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  },
  metaDivider: {
    width: '1px',
    backgroundColor: '#232e46',
    alignSelf: 'stretch'
  },
  notes: {
    marginTop: '12px',
    borderRadius: '12px',
    border: '1px solid #3a3320',
    backgroundColor: 'rgba(245, 158, 11, 0.08)',
    padding: '10px 14px',
    fontSize: '12.5px',
    lineHeight: '18px',
    color: '#d6c79a'
  }
}

export default function BookmakerList() {
  const { hasAccess, hadTrial, loading: authLoading } = useAuth()
  const isLocked = !authLoading && !hasAccess('education')
  const [search, setSearch] = useState('')
  const [companyFilter, setCompanyFilter] = useState('')
  const [oddsFeedFilter, setOddsFeedFilter] = useState('')

  // Get unique companies and odds feeds for filters
  const companies = [...new Set(listedBookmakers.map(b => b.company))].sort()
  const oddsFeeds = [...new Set(listedBookmakers.map(b => b.oddsFeed))].sort()

  // Filter bookmakers
  const q = search.trim().toLowerCase()
  const filteredBookmakers = listedBookmakers
    .filter(b => !companyFilter || b.company === companyFilter)
    .filter(b => !oddsFeedFilter || b.oddsFeed === oddsFeedFilter)
    .filter(b => !q || b.name.toLowerCase().includes(q))
    .sort((a, b) => a.name.localeCompare(b.name))

  const hasFilters = !!(search || companyFilter || oddsFeedFilter)
  const clearAll = () => {
    setSearch('')
    setCompanyFilter('')
    setOddsFeedFilter('')
  }

  const openLink = (link) => {
    window.open(link, '_blank', 'noopener,noreferrer')
  }

  if (isLocked) {
    return (
      <div style={{ ...styles.container, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <PreviewWall
          title="Every Australian bookmaker, one list"
          features={['Supported status & odds feed supplier for each book', 'Deposit bonuses offered', 'Direct links to every bookmaker']}
          planName="Premium"
          accent="#60a5fa"
          hadTrial={hadTrial}
        />
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <style>{`
        .bm-card { transition: transform 0.15s ease, opacity 0.15s ease; -webkit-tap-highlight-color: transparent; }
        .bm-card:active { transform: scale(0.98); opacity: 0.9; }
        .bm-pill { -webkit-tap-highlight-color: transparent; }
        .bm-pill:active { opacity: 0.8; }
        .bm-row { -webkit-tap-highlight-color: transparent; transition: background 0.1s ease; }
        .bm-row:active, .bm-row:hover { background: rgba(255, 255, 255, 0.04) !important; }
        @keyframes bmFadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes bmSlideUp { from { opacity: 0; transform: translateY(14px) scale(0.98); } to { opacity: 1; transform: none; } }
        .bm-overlay { animation: bmFadeIn 0.15s ease; }
        .bm-panel { animation: bmSlideUp 0.2s cubic-bezier(0.16, 1, 0.3, 1); }
      `}</style>

      {/* Search + filters — sticky under the app header */}
      <div style={styles.stickyBar}>
        <div style={styles.searchBox}>
          <SearchIcon />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search bookmakers…"
            style={styles.searchInput}
            autoCorrect="off"
            autoCapitalize="none"
          />
          {search && (
            <button onClick={() => setSearch('')} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex' }}>
              <XCircleIcon />
            </button>
          )}
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <SelectFilter label="Companies" value={companyFilter} options={companies} onChange={setCompanyFilter} />
          <SelectFilter label="Odds Feeds" value={oddsFeedFilter} options={oddsFeeds} onChange={setOddsFeedFilter} />
        </div>

        {/* Result count + clear */}
        <div style={styles.countRow}>
          <span style={styles.countText}>{filteredBookmakers.length} of {listedBookmakers.length} bookmakers</span>
          {hasFilters && (
            <button onClick={clearAll} style={styles.clearBtn}>
              <XCircleIcon size={13} color="#60a5fa" />
              Clear filters
            </button>
          )}
        </div>
      </div>

      {/* Cards */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {filteredBookmakers.map(bookmaker => {
          const t = statusTheme(bookmaker.supported, bookmaker.ceased)
          const hasBonus = !bookmaker.ceased && !!bookmaker.depositBonus
          return (
            <div
              key={bookmaker.id}
              className="bm-card"
              style={bookmaker.ceased ? styles.cardCeased : styles.card}
              onClick={() => openLink(bookmaker.link)}
            >
              {/* Header: logo tile + name/status + deposit bonus chip */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={styles.logoTile}>
                  <span style={styles.logoFallback}>{bookmaker.name.charAt(0)}</span>
                  <img
                    src={bookmaker.logo}
                    alt={`${bookmaker.name} logo`}
                    style={styles.logo}
                    onError={(e) => { e.currentTarget.style.display = 'none' }}
                  />
                  {!bookmaker.ceased && (
                    <div style={styles.linkBadge}>
                      <LinkIcon />
                    </div>
                  )}
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={styles.name}>{bookmaker.name}</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '4px' }}>
                    <div style={{ width: '7px', height: '7px', borderRadius: '4px', backgroundColor: t.dot }} />
                    <span style={{ fontSize: '12px', fontWeight: '500', color: t.chipText }}>{t.label}</span>
                  </div>
                </div>

                {!bookmaker.ceased && (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', flexShrink: 0 }}>
                    <span style={styles.bonusLabel}>Deposit Bonus</span>
                    <span style={{
                      ...styles.bonusChip,
                      backgroundColor: hasBonus ? 'rgba(16, 185, 129, 0.14)' : 'rgba(100, 116, 139, 0.12)',
                      color: hasBonus ? '#6ee7b7' : '#94a3b8'
                    }}>
                      {bookmaker.depositBonus || 'N/A'}
                    </span>
                  </div>
                )}
              </div>

              {/* Meta row */}
              <div style={styles.metaPanel}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={styles.metaLabel}>Odds Feed</div>
                  <div style={styles.metaValue}>{bookmaker.oddsFeed}</div>
                </div>
                <div style={styles.metaDivider} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={styles.metaLabel}>Company</div>
                  <div style={styles.metaValue}>{bookmaker.company}</div>
                </div>
              </div>

              {/* Notes callout */}
              {!bookmaker.ceased && bookmaker.notes && (
                <div style={styles.notes}>{bookmaker.notes}</div>
              )}
            </div>
          )
        })}

        {/* Empty state */}
        {filteredBookmakers.length === 0 && (
          <div style={{ marginTop: '64px', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 32px' }}>
            <SearchIcon size={36} color="#33455f" />
            <div style={{ marginTop: '12px', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
              No bookmakers match your filters.
            </div>
            {hasFilters && (
              <button
                onClick={clearAll}
                style={{ marginTop: '16px', padding: '8px 16px', borderRadius: '8px', border: '1px solid #1b2538', backgroundColor: 'transparent', fontSize: '13px', fontWeight: '600', color: '#60a5fa', cursor: 'pointer' }}
              >
                Clear filters
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
